import React from 'react'
import { Link } from 'gatsby'
import parser from 'html-react-parser'

export default function Highlight6({ data }) {
    const { highlight6ButtonText, highlight6ButtonLink, highlight6Text, highlight6Title, highlight6ButtonExternalLink } = data
    return (
        <div className='wemust-wrap csp-wemust-wrap font-white'>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-12 text-center'>
                        <div className='lg-font-140 yellow-gradient '>
                            {highlight6Title && parser(highlight6Title)}
                        </div>
                    </div>
                    <div className='col-md-12 text-center'>
                        <div className='heading-level-2-i white-color text-uppercase text-center'>
                            {highlight6Text && parser(highlight6Text)}
                        </div>
                        {highlight6ButtonExternalLink ? (
                            <a href={highlight6ButtonExternalLink} className="btn blue-btn">
                                {highlight6ButtonText}
                            </a>
                        ) : highlight6ButtonLink ? (
                            <Link to={highlight6ButtonLink.uri} className='btn blue-btn'>
                                {highlight6ButtonText}
                            </Link>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    )
}
